<style scoped>
.success-banner {
  width: 100%;
  background: white;
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.icon-container {
  background: #6abf69;
  padding: 20px;
}

.check-icon {
  width: 40px;
  height: 40px;
}

.message {
  padding: 15px;
  font-family: Arial, sans-serif;
  color: #333;
}

.message h2 {
  font-size: 18px;
  margin: 10px 0;
  font-weight: bold;
}

.message p {
  font-size: 14px;
  color: #666;
}
</style>
<template>

  <div class="container">

    

    <div v-if="showSuccessAlert" class="success-banner">
      <div class="icon-container">
        <svg class="check-icon" viewBox="0 0 24 24">
          <path fill="white" d="M9 16.2l-4.2-4.2-1.4 1.4L9 19 21 7l-1.4-1.4z" />
        </svg>
      </div>
      <div class="message">
        <h2>Todo salio bién</h2>
        <p>gracias por actualizar tu firma!</p>
      </div>
    </div>

    <div v-if="loading">
      <p>Cargando datos...</p>
    </div>
    <div v-else>
      <h1>Formulario de Apto Médico</h1>
      <AptoMedicoForm :token="token" />
    </div>

 
  </div>
</template>

<script>

import api from '../../../api/aptos';
import AptoMedicoForm from './components/AptoMedicoForm.vue';

export default {

  components: {
    AptoMedicoForm
  },

  props: {


  },

  data() {
    return {
      loading: true,      
      token: null,
    }
  },
  mounted() {
    // Supone que el token se pasa en la URL como query param (e.g., ?token=...)
    const token = this.$route.params.token;
    if (token) {
      this.token = token;
      this.validateToken(token);

    } else {
      console.error("Token no encontrado en la URL");
    }
  },
  methods: {
    async validateToken(token) {


      api.getTokenInfo(token)
        .then(response => {
          this.token = response.data.token;
          this.loading = false;
        })
        .catch(error => {
          console.error("Error al obtener la información:", error);
          this.$router.push({ name: "not-found" });
        }).finally(() => {
          this.loading = false;
        });

    },
 
  }
}

</script>